import React from "react";
import { AiOutlineUpload, AiOutlineVideoCamera } from "react-icons/ai";
import FilterMenu from "./FilterMenu";

interface CollectionHeaderProps {
    name: string;
    isCollectionOwner: boolean;
    onUpload: () => void;
    videosCount: number;
    totalDuration: string;
    filterQuery: string;
    onFilter: (query: string) => void;
    sortOptions: Array<{ label: string; value: string }>;
    selectedSort: string;
    onSortChange: (value: string) => void;
    expired?: boolean;
}

const CollectionHeader = React.memo<CollectionHeaderProps>(
    ({
        name,
        isCollectionOwner,
        onUpload,
        videosCount,
        totalDuration,
        filterQuery,
        onFilter,
        sortOptions,
        selectedSort,
        onSortChange,
        expired,
    }) => {
        return (
            <div className="space-y-4">
                {expired && (
                    <div className="bg-red-500 text-white text-center py-2 px-4 rounded-md font-semibold">
                        COLLECTION IS EXPIRED
                    </div>
                )}
                <div className="flex justify-center items-center mb-4">
                    <div className="flex flex-col justify-center w-full">
                        <h1 className="text-4xl font-bold">{name}</h1>
                    </div>

                    <div className="flex justify-end gap-5">
                        {isCollectionOwner && (
                            <button
                                className={`btn btn-primary text-white ${expired ? "btn-disabled" : ""}`}
                                onClick={onUpload}
                                disabled={expired}
                            >
                                <AiOutlineUpload size={18} />
                                Upload
                            </button>
                        )}
                    </div>
                </div>

                <div className="divider"></div>

                <div className="flex justify-between mb-5">
                    <div className="flex items-center gap-3">
                        <p className="flex items-center text-gray-500">
                            <AiOutlineVideoCamera className="mr-2" size={20} />
                            {videosCount} videos ({totalDuration})
                        </p>
                    </div>
                    <FilterMenu
                        onFilter={onFilter}
                        sortOptions={sortOptions}
                        selectedSort={selectedSort}
                        onSortChange={onSortChange}
                    />
                </div>
            </div>
        );
    }
);

export default CollectionHeader;
